var _path;
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId;
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9931 0.782227H3.07044C2.45502 0.782227 1.86481 1.0267 1.42964 1.46187C0.994474 1.89704 0.75 2.48725 0.75 3.10267L0.75 17.7988H19.3135V3.10267C19.3135 2.48725 19.0691 1.89704 18.6339 1.46187C18.1987 1.0267 17.6085 0.782227 16.9931 0.782227ZM3.07044 2.32919H16.9931C17.1982 2.32919 17.395 2.41068 17.54 2.55573C17.6851 2.70079 17.7666 2.89753 17.7666 3.10267V3.61858L11.6731 9.71283C11.2372 10.147 10.647 10.3908 10.0318 10.3908C9.41653 10.3908 8.82635 10.147 8.39044 9.71283L2.29696 3.61858V3.10267C2.29696 2.89753 2.37845 2.70079 2.52351 2.55573C2.66856 2.41068 2.8653 2.32919 3.07044 2.32919ZM2.29696 16.2518V5.80985L7.29674 10.8065C8.02275 11.5307 9.00633 11.9374 10.0318 11.9374C11.0572 11.9374 12.0408 11.5307 12.7668 10.8065L17.7666 5.80985V16.2518H2.29696Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.39f1cbbfd0d4b60e5445fa5a107cb50a.svg";
export { ForwardRef as ReactComponent };